import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Constants from '../../config/constants';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle, searchData } from '../datatable/util';
import {
  addChillerToACCentral,
  removeChillerFromACCentral,
  editChillerInACCentral,
  addToBeCreatedChiller,
  removeToBeCreatedChiller,
  editToBeCreatedChiller,
} from '../../redux/ac_central/ac_central_actions';
import { searchChillerByText } from '../../redux/ac_central/chiller_actions';
import { defaultRejectHandler, fromCoolingCap, getStatusStyle } from '../../utils/utility';

export class ChillerDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'chiller.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'chiller.name',
        width: 200,
        ...textColumn,
        entity: {
          list: (text, page) => searchChillerByText(text, page)
            .then(response => response.data.map((chiller) => ({label: chiller.name, value: String(chiller.id), original:chiller}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('air type')}</b>,
        accessor: 'chiller.type',
        ...textColumn,
        width: 100,
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: data => `${fromCoolingCap(data.chiller.cooling_capacity, data.chiller.unit)} ${data.chiller.unit === 'KBTU' ? 'BTU' : data.chiller.unit}`,
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'chiller.power_required',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('CHP')}</b>,
        accessor: 'chiller.CHP',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'chiller.status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 60,
        ...textColumn,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {
      isShowCreateAC: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    if(filter!== undefined){
      this.setState({ search: filter })
    }
    this.setState({ categoryOption: category });
  }

  editItem(item) {
    this.setState({
        isShowEditModal: true,
        selectedItem: item.original,
      },
      () => {
        if (this.props.onEditItem) {
          this.props.onEditItem(this.state.selectedItem);
        }
      },
    );
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
      search,
    } = this.state;

    const {
      acCentralId,
      filtered,
      filteredCount,
      isLoading,
      addChiller,
      removeChiller,
      editChiller,
      isChillerAdding,
      isChillerEditing,
      isChillerRemoving,
      chillers,
      addToBeCreatedChiller,
      editToBeCreatedChiller,
      removeToBeCreatedChiller,
      t,
      mode,
    } = this.props;
    
    const accessor = (data) => data && data.chiller;

    const relationship = {
      create: (({ entityId, quantity, original }) => {
        if (mode === 'edit'){
          addChiller(acCentralId, entityId, quantity);
        } else {
          addToBeCreatedChiller(quantity, original, this.props.chillers);
        }
      }).bind(this),
      delete: (id, rel) => {
        if (mode === 'edit'){
          removeChiller(id, acCentralId);
        } else {
          removeToBeCreatedChiller(rel.chiller.id);
        }
      },
      edit: ({ id, quantity, chiller}) => {
        if (mode === 'edit'){
          editChiller(id, quantity);
        } else {
          editToBeCreatedChiller(chiller.id, quantity);
        }
      },
      isCreating: isChillerAdding,
      isEditing: isChillerEditing,
      isDeleting: isChillerRemoving,
    };

    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <RelationDataTable
            columns={this.columns}
            data={searchData(search, categoryOption, chillers, accessor)}
            relationship={relationship}
            relationshipNameAccessor={item => item.chiller.name}
            classNamePrefix="select-central-unit-chiller"
            onActionEdit={item => this.editItem(item)}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isChillerAdding: state.ac.central.isChillerAdding,
  isChillerEditing: state.ac.central.isChillerEditing,
  isChillerRemoving: state.ac.central.isChillerRemoving,
});

const mapDispatchToProps = dispatch => ({
  addChiller: (acCentralId, chillerId, quantity) => defaultRejectHandler(dispatch(addChillerToACCentral(acCentralId, chillerId, quantity))),
  addToBeCreatedChiller: (quantity, chiller, tobeCreatedchillerarry) => defaultRejectHandler(dispatch(addToBeCreatedChiller(quantity, chiller, tobeCreatedchillerarry))),
  removeChiller: (acCentralChillerId, acCentralId) => defaultRejectHandler(dispatch(removeChillerFromACCentral(acCentralChillerId, acCentralId))),
  removeToBeCreatedChiller: (chillerId) => defaultRejectHandler(dispatch(removeToBeCreatedChiller(chillerId))),
  editChiller: (acCentralChillerId, quantity) => defaultRejectHandler(dispatch(editChillerInACCentral(acCentralChillerId, quantity))),
  editToBeCreatedChiller: (chillerId, quantity) => defaultRejectHandler(dispatch(editToBeCreatedChiller(chillerId, quantity))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ChillerDataTable),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/ChillerDataTable.js